module.exports = __webpack_public_path__ + "img/etiqueta.0f5c49c0.png";